import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import api from '../app/api';
import { authStore } from '../entity/auth/auth-store';

export const Route = createFileRoute('/_authenticated')({
    beforeLoad: async () => {
        let { user } = authStore.getState();

        if (!user) {
            user = await api.user.getMe();
        }

        if (user) {
            authStore.setState({
                user,
            });
            return;
        }

        throw redirect({
            to: '/auth',
        });
    },
    component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
    return <Outlet />;
}
